import { Conditional, Heading, If, Row } from "@hex-insights/core";
import { InviteButtonPermissionRequired, ParentPortalInviteButton } from "../../../../../Components/InviteButton";
import { GuardianDetailQuery, UserStatus } from "../../../../../Utilities";
import { PersonFormat } from "../../../../Format";
import { SendMessageButton } from "../../../MessageGroup";
import { GuardianIconWithFullModal } from "../../Icon";

export type HeaderProps = {
	guardian: GuardianDetailQuery["guardian"];
};

export function Header({ guardian }: HeaderProps) {
	return (
		<Row justify="spaced-start" align="center">
			<GuardianIconWithFullModal guardian={guardian} size={86} />

			<Row justify="space-between" align="center" style={{ flexGrow: 1 }}>
				<Heading.H1 noMargin>
					{PersonFormat.Fields.name(guardian.person.name)}
					{/* Instead of GuardianFormat.name or PersonFormat.name so that "You" is not displayed */}
				</Heading.H1>

				{!!guardian.person.user && (
					<Conditional>
						<If
							condition={
								guardian.person.user.status === UserStatus.Created || guardian.person.user.status === UserStatus.Invited
							}
						>
							<InviteButtonPermissionRequired>
								<ParentPortalInviteButton userID={guardian.person.user.id} />
							</InviteButtonPermissionRequired>
						</If>
						<If condition={guardian.person.user.status === UserStatus.Active}>
							<SendMessageButton userID={guardian.person.user.id} variant="primary" />
						</If>
					</Conditional>
				)}
			</Row>
		</Row>
	);
}
